import type { MouseEvent } from 'react'

import { FvLinkButton } from '@fv/client-components'

type TruckSelectorProps = {
  active: boolean
  className?: string
  selectTruck: () => void
  truckNumber: number
}

const TruckSelector = ({
  active,
  className,
  selectTruck,
  truckNumber,
}: TruckSelectorProps) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    selectTruck()
  }

  return (
    <FvLinkButton theme="pagination" active={active} onClick={handleClick}>
      {truckNumber}
    </FvLinkButton>
  )
}

export default TruckSelector
